import { render, staticRenderFns } from "./IndexNav.vue?vue&type=template&id=32736e44&scoped=true&"
import script from "./IndexNav.vue?vue&type=script&lang=js&"
export * from "./IndexNav.vue?vue&type=script&lang=js&"
import style0 from "./IndexNav.vue?vue&type=style&index=0&id=32736e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32736e44",
  null
  
)

export default component.exports